import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchAdminTabs } from "../api/tabsApi";
import { toast } from "react-toastify";

const ProtectedAdminRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    const checkTabAccess = async () => {
      try {
        const tabsData = await fetchAdminTabs();
        console.log("📋 Tabs data:", tabsData);
        
        // Normalize paths - paths from DB might already include /admin
        const allowedPaths = (tabsData.tabs || []).map(tab => {
          let tabPath = tab.path;
          // If path doesn't start with /admin, add it
          if (!tabPath.startsWith("/admin")) {
            tabPath = `/admin${tabPath}`;
          }
          return tabPath;
        });
        
        console.log("✅ Allowed paths:", allowedPaths);
        
        // Check if current path is in allowed tabs
        const currentPath = location.pathname;
        console.log("🔍 Checking current path:", currentPath);
        
        const isPathAllowed = allowedPaths.some(path => {
          const matches = currentPath.startsWith(path);
          console.log(`  Checking "${currentPath}" against "${path}": ${matches}`);
          return matches;
        });

        if (isPathAllowed) {
          console.log("✅ Access granted");
          setIsAuthorized(true);
        } else {
          console.warn(`❌ Unauthorized access attempt to: ${currentPath}`);
          toast.error("You don't have access to this tab");
          setIsAuthorized(false);
          navigate("/", { replace: true });
        }
      } catch (error) {
        console.error("❌ Error checking tab access:", error);
        toast.error("Error verifying access");
        navigate("/", { replace: true });
      }
    };

    checkTabAccess();
  }, [location.pathname, navigate]);

  // If still checking authorization, show loading
  if (isAuthorized === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Verifying access...</p>
        </div>
      </div>
    );
  }

  // If not authorized, don't render children
  if (!isAuthorized) {
    return null;
  }

  // If authorized, render the children
  return children;
};

export default ProtectedAdminRoute;
